'use client';
import useNavigate from '@/hooks/useNavigate';
import { useAppSelector } from '@/store/hooks';
import { PropsWithChildren, useEffect, useState } from 'react';

// @ts-ignore
const RestrictedPage: React.FC<
  { status: 'LOGGED_IN' | 'LOGGED_OUT'; pageName?: string } & PropsWithChildren
> = ({ status, pageName = 'NoCustomName', children }) => {
  const [waiting, setWainting] = useState<Boolean>(true);
  const navigate = useNavigate();
  const { isAuthenticated, forceLogout } = useAppSelector(
    (state) => state.auth,
  );

  useEffect(() => {
    if (
      (isAuthenticated && status === 'LOGGED_IN') ||
      (!isAuthenticated && status === 'LOGGED_OUT')
    ) {
      setWainting(false);
    } else if (status === 'LOGGED_IN' && !forceLogout) {
      navigate('login');
    } else navigate('');
  }, [isAuthenticated, status]);

  return waiting ? '' : children;
};

export default RestrictedPage;
